module.exports = __webpack_public_path__ + "static/media/logbook.5f1033ca.svg";